const EVENTS = {
  CLICK_SHOP_CTA: 'clickShopCTA - promoSection',
  WATCH_VIDEO: 'watchVideo - promoSection',
};

const IMAGE_HEIGHTS = {
  SMALL: 338,
  MEDIUM: 432,
  LARGE_UP: 542,
};

export { EVENTS, IMAGE_HEIGHTS };
